/* eslint-disable react-hooks/rules-of-hooks */
import React, { useEffect, useState } from 'react'

import Menu from '../../../components/Menu'

import Switch from "react-switch"

import { get, put } from '../../../services/http'
import { notify } from '../../../components/Toast'

import { ToastContainer } from 'react-toastify'
import { useNavigate } from 'react-router-dom'

import { useParams } from 'react-router'

export default function index() {
  const navigate = useNavigate()
  const { id } = useParams()

  const [supportSubject, setSupportSubject] = useState('')
  const [supportPart, setSupportPart] = useState('')
  const [supportMessage, setSupportMessage] = useState('')
  const [supportUser, setSupportUser] = useState('')
  const [supportUserPhone, setSupportUserPhone] = useState('')
  const [supportUserEmail, setSupportUserEmail] = useState('')
  const [supportStatus, setSupportStatus] = useState('')

  const token = localStorage.getItem('token')
  
  document.title = 'جزئیات پشتیبانی'

  useEffect(() => {
    get(`/api/admin/supports/${id}?token=${token}`)
      .then(response => {
        setSupportSubject(response.data.data[0].subject)
        setSupportPart(response.data.data[0].part)
        setSupportMessage(response.data.data[0].message)
        setSupportUser(response.data.data[0].user[0].name)
        setSupportUserPhone(response.data.data[0].user[0].phoneNumber)
        setSupportUserEmail(response.data.data[0].user[0].email)
        setSupportStatus(response.data.data[0].status)
      }).catch(error => {
        notify('error', 'دریافت اطلاعات با خطا مواجه شد')
      })
  }, [id, token])

  const statusHandler = () => {
    let data = { status: true }
    setSupportStatus(!supportStatus)
    if (supportStatus) {
      data = { status: false }
    } else {
      data = { status: true }
    }
    put(`/api/admin/supports/status/${id}?token=${token}`, data)
      .then(response => {
        notify('success', response.data.messageFa)
        setTimeout(() => {
          navigate('/supports')
        }, 2000)
      })
      .catch(error => {
        if (error) {
          notify('error', error)
        }
        notify('error', 'خطا در ارسال اطلاعات')
      })
  }

  return (
    <main id='panel'>
      <ToastContainer rtl />
      <Menu page={'support'} badgeCountDashboard={0} badgeCountOrder={0} />
      <article className='panelBody'>
        <section className='panelContent'>
          <div className='title'>
            <div className='right' style={{ width: '100%', display: 'flex', justifyContent: 'space-between' }}>
              <div className='text' >
                <div>
                </div>
                <Switch onChange={statusHandler} 
                  checked={supportStatus ? supportStatus : false} 
                  onColor="#86d3ff"
                  onHandleColor="#2693e6"
                  handleDiameter={30}
                  uncheckedIcon={false}
                  checkedIcon={false}
                  boxShadow="0px 1px 5px rgba(0, 0, 0, 0.6)"
                  activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
                  height={20}
                  width={48}
                  className="react-switch"
                  id="material-switch"
                  />
              </div>
              <div>
              </div>
            </div>

            <div className='left'>
            </div>
          </div>

          <form className='form'>
            <div className='title'>
              * با سوئیچ بالا میتوانید بررسی شدن یا نشدن آنرا مشخص کنید.
            </div>
            <div className='lineTitleFood'>
              <hr />
              اطلاعات پشتیبانی
              <hr />
            </div>
            <div className='row'>
              <div className='textarea'>
                <label htmlFor='foodName'>مشخصات :</label>
                <ul className='list'>
                  <li>موضوع : {supportSubject ? supportSubject : ''}</li>
                  <li>بخش : {supportPart ? supportPart : ''}</li>
                  <li>پیغام : {supportMessage ? supportMessage : ''}</li>
                  <li>نام کاربر ارسال کننده : {supportUser ? supportUser : ''}</li>
                  <li>شماره موبایل : {supportUserPhone ? supportUserPhone : ''}</li>
                  <li>آدرس ایمیل : {supportUserEmail ? supportUserEmail : ''}</li>
                </ul>
              </div>
            </div>
            <div className='row'>
              <div className='textarea'>
                <label htmlFor='foodName'>وضعیت :</label>
                <ul className='list'>
                  <li style={supportStatus ? { color: '#198524' } : { color: '#fd3a50' }}>وضعیت : {supportStatus ? 'بررسی شده' : 'بررسی نشده'}</li>
                </ul>
              </div>
            </div>
          </form>
          <div className='copyright'>
            © تمامی حقوق برای <a href='https://ibills.ir'>ibills</a> محفوظ است. طراحی و توسعه توسط <a href='https://ham-team.ir'>هم تیم</a>
          </div>
        </section>
      </article>
    </main>
  )
}
